import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-inverter",
  "use": "deviceData-inverter-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"deviceData-inverter\"><style>#deviceData-inverter .st0{fill:none}</style><title>资源 3</title><g id=\"deviceData-inverter_图层_2\"><g id=\"deviceData-inverter_编组_11备份_2\"><path class=\"st0\" d=\"M0 0h17v17H0z\" /><path d=\"M15.6 1.9c0-.5-.5-.9-1-.9H2.3c-.5 0-.9.4-1 .9v13.2c0 .5.4.9 1 .9h12.3c.5 0 .9-.4 1-.9V1.9zM4.5 5.1h8.3v1.3H4.5V5.1z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-inverter.svg
// module id = JyBt
// module chunks = 6